/**
 * @file IO工具函数
 *
 * @author 天翔Skyline(skyline0705@gmail.com)
 * May 15, 2019
 */

export function transToFormData(data: any) {
    const formData = new FormData();
    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            formData.append(key, JSON.stringify(data[key]));
        }
    }
    return formData;
}
